const SourceSansPro_400Regular = {fontFamily: 'SourceSans3-Regular'};
const SourceSansPro_600SemiBold = {fontFamily: 'SourceSans3-SemiBold'};

export const fonts = {
  SourceSansPro_400Regular: {...SourceSansPro_400Regular},
  SourceSansPro_600SemiBold: {...SourceSansPro_600SemiBold},
};
